/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Handle product gallery lazysizes
// PageFly custom JS code - Do Not Delete
try {
  window.addEventListener("load", function() {
      console.info("Running PF Code");
      var updateProuctImage = function() {
        var count = 0;
        var iId = setInterval(function() {
            console.info("PF:  Detecting DOM change", count);
            document.querySelectorAll(".__pf .Product__SlideItem--image img").forEach($img => {
                if (!$img.src) {
                    $img.src = $img.dataset.originalSrc;
                }
            });
            count += 1;
            if (count === 20) { clearInterval(iId) }
        }, 300)   
      }
      updateProuctImage();

      // Update on chaging variant
      document.querySelectorAll(".ProductForm__Variants ul > li").forEach($li => {
          $li.addEventListener("click", updateProuctImage);
      })
  })
} catch(err) {
  console.error("PF:: ", err)
}